import { CheckHomeworkBatchPage } from "@/pages/teacher/CheckHomeworkBatchPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/teacher/check/$batchId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { batchId } = Route.useParams();
  return <CheckHomeworkBatchPage batchId={batchId} />;
}
